export default __webpack_public_path__ + "static/media/solpanel.41c45163.jpeg";